import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5438_9957)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.4684 24.2419C15.9924 24.2419 19.1626 22.7309 21.363 20.323L20.7775 19.6786C20.0529 18.881 18.8177 18.8128 18.0088 19.5258L16.7598 20.6268C15.0607 22.1246 12.478 22.0301 10.894 20.4123L10.113 19.6146C9.36306 18.8486 8.13421 18.822 7.35133 19.5547L5.06058 21.6984C7.10279 23.2921 9.67436 24.2419 12.4684 24.2419ZM22.4702 18.1573L22.7545 18.4703C23.8621 16.6547 24.5 14.5227 24.5 12.2419C24.5 9.47648 23.5621 6.92949 21.9861 4.90017C21.6932 4.97507 21.4132 5.11841 21.1714 5.33156L19.9224 6.43251C18.2233 7.93033 15.6406 7.83592 14.0566 6.21806L13.2756 5.42041C12.5256 4.65445 11.2968 4.62775 10.5139 5.3604L7.30042 8.36779L5.73708 6.71536L8.95058 3.70796C10.6399 2.12696 13.2917 2.18458 14.91 3.83746L15.6909 4.63511C16.4251 5.38484 17.6219 5.42859 18.4093 4.73448L19.6582 3.63353C19.8679 3.44876 20.0907 3.28832 20.3234 3.15197C18.2156 1.33852 15.4704 0.241943 12.4684 0.241943C6.43258 0.241943 1.43485 4.67474 0.569346 10.4543C2.21636 9.50871 4.35491 9.75592 5.73829 11.1688L6.64147 12.0913C7.34349 12.8084 8.47595 12.884 9.26806 12.2667L11.9454 10.1805C13.5524 8.92838 15.8274 8.98895 17.3647 10.3248L21.0103 13.4928L19.5094 15.2014L15.8637 12.0335C15.1513 11.4144 14.097 11.3863 13.3524 11.9667L10.675 14.0529C8.96568 15.3848 6.52196 15.2215 5.00707 13.6743L4.1039 12.7518C3.35394 11.9859 2.12509 11.9591 1.34222 12.6918L0.5 13.48C0.760464 16.0146 1.81188 18.3155 3.40401 20.1333L5.788 17.9022C7.47736 16.3212 10.1291 16.3788 11.7474 18.0317L12.5284 18.8293C13.2625 19.579 14.4593 19.6229 15.2467 18.9288L16.4957 17.8278C18.241 16.2892 20.9066 16.4363 22.4702 18.1573Z"
        fill="#ECEDEE"
      />
    </g>
    <defs>
      <clipPath id="clip0_5438_9957">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.5 0.241943)"
        />
      </clipPath>
    </defs>
  </svg>
)
